var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var PageModal = function(el) {
  var self = this;
  this.$modal = $(el);
  this.$dim = $('#ModalDim');

  $( document ).on( 'OpenModal', function( event, content ) {
    // Show modal
    self.$modal.show();
    self.$dim.show();

    $(window).resize(function() {
      self.sizeModal();
    }).trigger('resize');

    if(content == 'loading') {
      // Show loading message
      self.$modal.find('.modal-content').html('').hide();
      self.$modal.find('.modal-loading').show();
    } else {
      // Populate modal
      self.$modal.find('.modal-content').html(content).show();
      self.$modal.find('.modal-loading').hide();
    }
    // Dim page
    $('body').addClass('show-modal');
  });

  $( document ).on( 'CloseModal', function( event ) {
    // Hide modal
    self.$modal.hide();
    self.$dim.hide();
    // Un-dim page
    $('body').removeClass('show-modal');
  });

  // Bind events
  this.$modal.on('click', '.modal-close', function(event){
    event.preventDefault();
    $( document ).trigger( 'CloseModal' );
  });
  this.$dim.on('click', function(event){
    event.preventDefault();
    $( document ).trigger( 'CloseModal' );
  });

  this.$modal.on('click', '.modal-content > * > *', function(event) {
    event.stopPropagation();
  });

};

PageModal.prototype = {

  /** Open the source group **/
  sizeModal: function() {

    /*var top = $(document).scrollTop();
    this.$modal.css({
      top: top+'px',
      height: 'auto',
    });

    if(this.$modal.height() < window.innerHeight) {
      this.$modal.css({
        height: window.innerHeight+'px'
      });
    }*/

  }

};

module.exports = PageModal;
